module.exports = __webpack_public_path__ + "img/chinesecompany165.df20d2e5.png";